module.exports = __webpack_public_path__ + "img/right.0cf9a6b6.png";